import Model from './Model'
export default class Transport extends Model {

    resource()
    {
        return 'transports'
    }

    get currencies () {
        return [{
            id: 'EUR_VAT_EXCL',
            text: 'EURO fara TVA'
        },{
            id: 'EUR_VAT_INCL',
            text: 'EURO cu TVA'
        },{
            id: 'RON_VAT_EXCL',
            text: 'RON fara TVA'
        },{
            id: 'RON_VAT_INCL',
            text: 'RON cu TVA'
        }]
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download`
    }
}
